import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
// NOTA: Se ha eliminado la dependencia a './CartContext' y 'useCart'
// para que el componente sea funcional en un solo archivo.
// La lógica de estado para 'selectedCategories' ahora es local.
import CategoryHeader  from './CategoryHeader';
import { TRANSLATIONS } from './i18n/translations';
import FileUploadModal from './components/FileUploadModal';
import { FiUpload, FiShoppingCart, FiArrowLeft,FiList,FiTrash,FiCheck   } from 'react-icons/fi';
import { MdClose, MdBookmarkBorder, MdBookmark } from 'react-icons/md';
import { AiOutlineClose } from 'react-icons/ai';
import * as LucideIcons from 'lucide-react';
import ShoppingListModal from './components/ShoppingListModal';
import ItemSearchModal from './components/ItemSearchModal';
import SubcategoryItemsModal from './components/SubcategoryItemsModal';
import WatchedItemsModal, { getPriceStatus } from './components/WatchedItemsModal';
import ChooseCartItemModal from './components/ChooseCartItemModal';
import ProductDetails from './components/ProductDetails';
import WatchedCategoriesModal, { normalizeWatchedCategories } from './components/WatchedCategoriesModal';
import SlidePanel from './components/SlidePanel';
import AskCopilotModal from './components/AskCopilotModal';
import useIsMobile from './useIsMobile';
import { analyticsEvents } from "./analytics/analytics";
import { getIconName } from './icons';
import { onAuthChange, isGoogleUser } from './authSession';
import { apiFetch } from './api';
const API_URL = process.env.REACT_APP_API_URL;
const HEADER_HEIGHT = 30;
 const baseButtonStyle = {
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '5px 10px',
          borderRadius: '8px',
          border: 'none',
          fontSize: '1em',
          fontWeight: 600,
          color: '#ffffff',
          boxSizing: 'border-box',
          overflowX: 'hidden',
          cursor: 'pointer',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        };




// Iconos SVG simples para el carrito (Añadir/Remover)
const CartIcon = ({ isSelected }) => (
    <span style={{ transition: 'all 0.2s', display: 'flex' }}>
        {isSelected ? (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="24"
                height="24"
            >
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
        ) : (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="24"
                height="24"
            >
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <line x1="18" y1="5" x2="18" y2="11" strokeWidth="3.0"></line>
                <line x1="15" y1="8" x2="21" y2="8" strokeWidth="3.0"></line>
            </svg>
        )}
    </span>
);

const CategoryIcon = ({ categoryKey }) => {
  const iconName = getIconName(categoryKey);
  const IconComponent = LucideIcons[iconName] || LucideIcons.ShoppingBasket;

  return <IconComponent size={24} />;
};

const QuantityStepper = ({ quantity, onDecrease, onIncrease }) => (
  <div
    data-testid="quantity-stepper"
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    }}
  >
    <button
      onClick={(e) => {
        e.stopPropagation();
        onDecrease();
      }}
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        border: '1px solid #d1d5db',
        background: '#fff',
        cursor: 'pointer',
        fontSize: '1.2em',
        fontWeight: 700,
      }}
    >
      -
    </button>

    <div
      style={{
        minWidth: '42px',
        height: '36px',
        borderRadius: '10px',
        border: '1px solid #d1d5db',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        background: '#f8fafc',
      }}
    >
      {quantity}
    </div>

    <button
      onClick={(e) => {
        e.stopPropagation();
        onIncrease();
      }}
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        border: '1px solid #14532D',
        background: '#14532D',
        color: '#fff',
        cursor: 'pointer',
        fontSize: '1.2em',
        fontWeight: 700,
      }}
    >
      +
    </button>
  </div>
);

// Función para agrupar categorías
const groupCategoriesByItemCategory = (flatCategories) => {
    const grouped = flatCategories.reduce((acc, categoryObj) => {
        const key = categoryObj.itemCategory;
        if (!acc[key]) {
            acc[key] = { itemCategory: key, itemCategory_es: categoryObj.itemCategory_es, categories: [] };
        }
        acc[key].categories.push(categoryObj);
        return acc;
    }, {});
    return Object.values(grouped);
};

// =================================================================
// --- COMPONENTE PRINCIPAL PRODCATEGORIES ---
// =================================================================
function ProdCategories() {

    const VIEW_MODES = {
      CATEGORIES: 'categories',
      ITEMS: 'items',
    };
    // LocalStorage keys
    const LS_SELECTED_CATEGORIES = 'shopcopilot:selectedCategories';
    const LS_SELECTED_ITEM_QUANTITIES = 'shopcopilot:selectedItemQuantities';
    const LS_SELECTED_STORES = 'shopcopilot:selectedStores';
    const LS_VIEW_MODE = 'shopcopilot:viewMode';
    const LS_COLLAPSED_RESULT_CATEGORIES = 'shopcopilot:collapsedResultCategories';
    const LS_SORT_BY_UNIT_PRICE = 'shopcopilot:sortByUnitPrice';
    // Firebase session drives login state - anonymous sessions (used for
    // general API access) don't count as logged in.
    const [isLoggedIn, setIsLoggedIn] = useState(() => isGoogleUser());
    // SHOP-16: profile data for the header avatar (email/name/picture_url), fetched
    // separately since the JWT itself only carries the user's email as `sub`.
    const [userProfile, setUserProfile] = useState(null);
    const [isItemSearchOpen, setIsItemSearchOpen] = useState(false);
    const [isAskCopilotOpen, setIsAskCopilotOpen] = useState(false);
    const [allItems, setAllItems] = useState([]);
    const [isLoadingAllItems, setIsLoadingAllItems] = useState(false);
    const [itemSearchText, setItemSearchText] = useState('');
    const [itemSearchResults, setItemSearchResults] = useState([]);
    const [expandedCategories, setExpandedCategories] = useState({});
    const [watchedItemIds, setWatchedItemIds] = useState({});
    // SHOP-61: count of watched items currently at/under the price-alert
    // threshold (SHOP-58/60), surfaced as a badge on the header's three-dot
    // menu and highlighted next to "My Watched Items" in the dropdown.
    const [watchedItemsAlertCount, setWatchedItemsAlertCount] = useState(0);
    // Guards against firing overlapping /watchlist requests for the same
    // productid if the toggle button is clicked again before the first
    // request resolves.
    const watchRequestsInFlightRef = useRef({});
    // SHOP-40/43: mirrors watchedItemIds/watchRequestsInFlightRef above, but
    // keyed by the normalized category name (group.category) instead of
    // productid, for the category-group watch toggle.
    const [watchedCategoryNames, setWatchedCategoryNames] = useState({});
    const categoryWatchRequestsInFlightRef = useRef({});

    // --- ESTADO DE LENGUAJE ---
    const [language, setLanguage] = useState('es');
    const translations = TRANSLATIONS[language]; // Objeto de traducción activo
    const [toast, setToast] = useState(null);
    // 🔹 NUEVOS ESTADOS PARA CANASTA ÚNICA / AHORROS
    const [basketTopPrice, setBasketTopPrice] = useState(null);
    const [savings, setSavings] = useState(null);
    const [finalPrice, setFinalPrice] = useState(null);
    const [stores, setStores] = useState([]);
    const [selectedStores, setSelectedStores] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_SELECTED_STORES);
        return stored ? JSON.parse(stored) : [];
      } catch {
        return [];
      }
    });
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const isMobile = useIsMobile();

    // SHOP-204: the SHOP-194 toggle for this is now hidden from the UI - item
    // listing/basket screens always behave as if it were ON (only items with
    // a currently-valid enddate, excluding the fallback to regular_price for
    // expired items), with no persisted override.
    const onlyActiveItems = true;

    // SHOP-197: per-browser toggle - when active, items within each
    // basket-result category card are sorted by unit_price (falling back to
    // price for items with no unit_price) instead of the backend's default
    // total-price order.
    const [sortByUnitPrice, setSortByUnitPrice] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_SORT_BY_UNIT_PRICE);
        return stored ? JSON.parse(stored) : false;
      } catch {
        return false;
      }
    });

    const handleToggleSortByUnitPrice = useCallback(() => {
      setSortByUnitPrice(prev => !prev);
    }, []);

    // SHOP-196: per-category collapse/expand for the ITEMS-view basket-result
    // cards, distinct from expandedCategories (which controls "Mostrar
    // más/menos" within an already-visible category).
    const [collapsedResultCategories, setCollapsedResultCategories] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_COLLAPSED_RESULT_CATEGORIES);
        return stored ? JSON.parse(stored) : {};
      } catch {
        return {};
      }
    });

    const toggleResultCategoryCollapse = useCallback((categoryName) => {
      setCollapsedResultCategories(prev => ({
        ...prev,
        [categoryName]: !prev[categoryName],
      }));
    }, []);

    // SHOP-198: visual-only hover affordance for the result-category header
    // (SHOP-196's collapse/expand target) - only one header can be hovered
    // at a time, so a single value is enough, mirroring CategoryHeader.js's
    // hoveredItemKey pattern rather than a per-category map.
    const [hoveredResultCategory, setHoveredResultCategory] = useState(null);

    const [viewMode, setViewMode] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_VIEW_MODE);
        return stored || VIEW_MODES.CATEGORIES;
      } catch {
        return VIEW_MODES.CATEGORIES;
      }
    });

    const getItemKey = useCallback((item) => {
      return String(item?.productid ?? '');
    }, []);

    const reconcilePersistedSession = useCallback((
      persistedSelections,
      persistedCategories,
      validItems,
      validCategories,
      activeStores
    ) => {
      const validItemKeys = new Set(
        (validItems || []).map(item => getItemKey(item))
      );

      const validCategoryNames = new Set(
        (validCategories || []).map(cat => cat.name)
      );

      const cleanedSelections = {};
      const categoriesWithValidItems = new Set();

        Object.entries(persistedSelections || {}).forEach(([, entry]) => {
          if (!entry?.item) return;

          const item = entry.item;
          const normalizedKey = getItemKey(item);

          if (!validItemKeys.has(normalizedKey)) return;
          if (!activeStores.includes(item.store)) return;
          if (!entry.quantity || entry.quantity <= 0) return;
          if (!validCategoryNames.has(entry.category)) return;

          cleanedSelections[normalizedKey] = {
            ...entry,
            item,
            category: item.category,
          };

          categoriesWithValidItems.add(item.category);
        });

      const cleanedCategories = (persistedCategories || []).filter(cat => {
        if (!cat?.name) return false;
        if (!validCategoryNames.has(cat.name)) return false;

        // IMPORTANTE:
        // Mantiene selección manual aunque no tenga items todavía
        return true;

        // Si quieres eliminar categorías sin items válidos:
        // return categoriesWithValidItems.has(cat.name);
      });

      return {
        cleanedSelections,
        cleanedCategories,
      };
    }, [getItemKey]);

 // Item seleccionado por categoría
    const [selectedItemQuantities, setSelectedItemQuantities] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_SELECTED_ITEM_QUANTITIES);
        return stored ? JSON.parse(stored) : {};
      } catch {
        return {};
      }
    });



  // Categorías seleccionadas (UI)
    const [selectedCategories, setSelectedCategories] = useState(() => {
      try {
        const stored = localStorage.getItem(LS_SELECTED_CATEGORIES);
//        console.log("Local Cats:",stored);
        return stored ? JSON.parse(stored) : [];
      } catch {
        return [];
      }
    });


    const handleResetAll = () => {
      setSelectedCategories([]);
      setSelectedItemQuantities({});
      setCheapestItems([]);
      setBasketTopPrice(null);
      setSavings(null);
      setFinalPrice(null);
      setViewMode(VIEW_MODES.CATEGORIES);
    };

    const toggleExpandedCategory = useCallback((categoryName) => {
      setExpandedCategories(prev => ({
        ...prev,
        [categoryName]: !prev[categoryName],
      }));
    }, []);


    const handleOpenFilter = () => {
      setIsFilterOpen(true);
    };


     const handleUploadSuccess = (toastData) => {
          setToast(toastData);

          setTimeout(() => {
            setToast(null);
          }, 2000);
        };

    // --- ESTADO DE MODALES ---
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isListModalOpen, setIsListModalOpen] = useState(false); // <--- RESTAURADO
    const [infoModalCategory, setInfoModalCategory] = useState(null);
    const [infoModalItems, setInfoModalItems] = useState([]);
    const [isWatchedItemsModalOpen, setIsWatchedItemsModalOpen] = useState(false); // TES-2/TES-4
    const [isWatchedCategoriesModalOpen, setIsWatchedCategoriesModalOpen] = useState(false); // SHOP-45

    // Función para obtener el título de grupo traducido
    const getTranslatedGroupTitle = useCallback(
      (item) => {
       return language === 'es'
        ? item.itemCategory_es || item.category_es || item.itemCategory
        : item.itemCategory || item.category;
      },
      [language]
    );

//    console.log('[Antes del sort] ProductsCategories - language:', language);
    const getSortedCategoriesByLanguage = (categories) => {
      return [...categories].sort((a, b) => {
        if (language === 'es'){
            const labelA = a.name_es || a.name;
            const labelB = b.name_es || b.name;
            return labelA.localeCompare(labelB, language);
            }
        else{
            const labelA = a.name;
            const labelB = b.name;
            return labelA.localeCompare(labelB, language);
        }
      });
    };

    // --- Nueva función simplificada ---
    const handleLanguageToggle = useCallback(() => {
        // Si el idioma actual es español, cambia a inglés; si no, a español.
        setLanguage(prevLang => (prevLang === 'es' ? 'en' : 'es'));
    }, []);


    const [categories, setCategories] = useState([]);
    const [groupedCategories, setGroupedCategories] = useState([]);
    const [collapsedGroups, setCollapsedGroups] = useState({}); // Se inicializa en useEffect


    // Data base (NO se muta)
    const handleCheckboxChange = (categoryObj) => {
      const categoryName = categoryObj.name;

      const isSelected = selectedCategories.some(
        (cat) => cat.name === categoryName
      );

      if (isSelected) {
        setSelectedCategories((prev) =>
          prev.filter((cat) => cat.name !== categoryName)
        );

        setSelectedItemQuantities((prev) => {
          const updated = { ...prev };

          Object.keys(updated).forEach((key) => {
            if (updated[key]?.category === categoryName) {
              delete updated[key];
            }
          });

          return updated;
        });
      } else {
        setSelectedCategories((prev) => [...prev, categoryObj]);

        analyticsEvents.selectCategory({
          categoryName,
          screenName: "categories",
          language,
        });
      }
    };


    const toggleGroup = useCallback((itemCategory) => {
        setCollapsedGroups(prev => ({
            ...prev,
            [itemCategory]: !prev[itemCategory]
        }));
    }, []);
    // Fin Lógica de Estado Local

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cheapestItems, setCheapestItems] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [headerHeight, setHeaderHeight] = useState(0);
    const MAX_VISIBLE_ALTS = 2;
    const [expandedAlternatives, setExpandedAlternatives] = useState({});
    const getItemQuantity = useCallback((item) => {
      const key = getItemKey(item);
      const legacyKey = `${item?.category}__${item?.productid}`;

      return (
        selectedItemQuantities[key]?.quantity ||
        selectedItemQuantities[legacyKey]?.quantity ||
        0
      );
    }, [selectedItemQuantities, getItemKey]);

    const updateItemQuantity = useCallback((item, nextQty) => {
      const key = getItemKey(item);

      // SHOP-34: bump the global cart-add count exactly once per add event --
      // the 0-to->0 transition -- not per click/unit. Fire-and-forget: no
      // rollback on failure, since this is a secondary analytics signal,
      // not user-facing cart state.
      const currentQty = getItemQuantity(item);
      if (currentQty === 0 && nextQty > 0) {
        apiFetch(`/cart-counts/${item.productid}`, { method: 'POST' })
          .catch(error => {
            console.error('Error incrementing cart-add count:', error);
          });
      }

      // SHOP-176: warn (without blocking) when an increment adds more of an
      // inactive/expired item, since its price may be stale. Only on a real
      // increment -- decreasing/removing from the cart never warns.
      if (nextQty > currentQty && item.is_regular_price) {
        setToast({ type: 'info', text: translations.expiredItemAddedToast });
        setTimeout(() => setToast(null), 2000);
      }

      setSelectedItemQuantities(prev => {
        const updated = { ...prev };

        if (nextQty <= 0) {
          delete updated[key];
        } else {
          updated[key] = {
            quantity: nextQty,
            item,
            category: item.category,
          };
        }

        if (shouldPersistRef.current) {
          localStorage.setItem(
            LS_SELECTED_ITEM_QUANTITIES,
            JSON.stringify(updated)
          );
        }

        return updated;
      });
    }, [getItemKey, getItemQuantity, translations]);


    const addItemToCart = useCallback((item) => {
      const currentQty = getItemQuantity(item);
      const nextQty = currentQty + 1;

      updateItemQuantity(item, nextQty);

      analyticsEvents.changeItemQuantity({
        item,
        quantity: nextQty,
        previousQuantity: currentQty,
        screenName: "items",
        language,
      });
    }, [getItemQuantity, updateItemQuantity, language]);

    // SHOP-131: on the 0->1 transition (first add, mirrors the cart-counts
    // 0->positive guard in updateItemQuantity above - not re-asking on every
    // subsequent + click), if the backend found a qualifying equivalent
    // (DBDao.get_matched_equivalents, >= add_to_cart_equivalent_min_score)
    // for this item, ask which one(s) to add instead of adding it directly.
    const [cartChooserItem, setCartChooserItem] = useState(null);

    const increaseItemQuantity = useCallback((item) => {
      const currentQty = getItemQuantity(item);

      if (currentQty === 0 && item.matched_equivalent) {
        setCartChooserItem(item);
        return;
      }

      addItemToCart(item);
    }, [getItemQuantity, addItemToCart]);

    const handleChooseCartItem = useCallback((chosenItem) => {
      addItemToCart(chosenItem);
      setCartChooserItem(null);
    }, [addItemToCart]);

    const handleChooseBothCartItems = useCallback(() => {
      if (!cartChooserItem) return;
      addItemToCart(cartChooserItem);
      addItemToCart(cartChooserItem.matched_equivalent);
      setCartChooserItem(null);
    }, [cartChooserItem, addItemToCart]);

    const handleCancelCartChooser = useCallback(() => {
      setCartChooserItem(null);
    }, []);

    // 2. FUNCIÓN: Maneja la selección de un artículo (principal o alternativo)
    const handleItemSelection = useCallback((categoryName, item) => {
      increaseItemQuantity(item);
    }, [increaseItemQuantity]);



// Se ejecuta cuando los resultados de la búsqueda cambian

    const isExpanded = (category) => !!expandedAlternatives[category];

    const toggleExpanded = (category) => {
      setExpandedAlternatives(prev => ({
        ...prev,
        [category]: !prev[category]
      }));
    };



    const decreaseItemQuantity = useCallback((item) => {
      const currentQty = getItemQuantity(item);
      const nextQty = Math.max(0, currentQty - 1);

      updateItemQuantity(item, nextQty);

      analyticsEvents.changeItemQuantity({
        item,
        quantity: nextQty,
        previousQuantity: currentQty,
        screenName: "items",
        language,
      });
    }, [getItemQuantity, updateItemQuantity, language]);

    const getSelectedCountByCategory = useCallback((categoryName) => {
      return Object.values(selectedItemQuantities)
        .filter(entry => entry.category === categoryName)
        .reduce((sum, entry) => sum + (entry.quantity || 0), 0);
    }, [selectedItemQuantities]);

    const getCategorySubtotal = useCallback((categoryName) => {
      return Object.values(selectedItemQuantities)
        .filter(entry => entry.category === categoryName)
        .reduce((sum, entry) => {
          const price = parseFloat(String(entry.item.price).replace(/[^0-9.-]+/g, '')) || 0;
          return sum + (price * entry.quantity);
        }, 0);
    }, [selectedItemQuantities]);


    const visibleCheapestItems = cheapestItems.filter(mainItem =>
      selectedCategories.some(
        cat => cat.name === mainItem.category
      )
    );


    const groupedVisibleItems = useMemo(() => {
      const groups = visibleCheapestItems.map(mainItem => {
        const items = [mainItem, ...(mainItem.AlternativeItems || [])];

        // Winners are computed from the unsorted group so both badges stay
        // pinned to the actual cheapest item regardless of the toggle/sort.
        const priceWinnerId = mainItem.productid;
        let unitPriceWinnerId = null;
        let lowestUnitPrice = null;
        items.forEach(item => {
          if (item.unit_price == null) return;
          if (lowestUnitPrice === null || item.unit_price < lowestUnitPrice) {
            lowestUnitPrice = item.unit_price;
            unitPriceWinnerId = item.productid;
          }
        });

        const sortedItems = sortByUnitPrice
          ? [...items].sort((a, b) => {
              const aKey = a.unit_price ?? a.price;
              const bKey = b.unit_price ?? b.price;
              return aKey - bKey;
            })
          : items;

        return {
          category: mainItem.category,
          title: getTranslatedGroupTitle(mainItem),
          items: sortedItems,
          priceWinnerId,
          unitPriceWinnerId,
        };
      });

      return [...groups].sort((a, b) => a.title.localeCompare(b.title, language));
    }, [visibleCheapestItems, getTranslatedGroupTitle, sortByUnitPrice, language]);

    const flattenedSelectedItemsMap = useMemo(() => {
      const flat = {};

      Object.values(selectedItemQuantities).forEach((entry, index) => {
        flat[`selected_${index}`] = {
          ...entry.item,
          quantity: entry.quantity,
          line_total: (parseFloat(String(entry.item.price).replace(/[^0-9.-]+/g, '')) || 0) * entry.quantity,
        };
      });

      return flat;
    }, [selectedItemQuantities]);

    useEffect(() => {
        localStorage.setItem(LS_VIEW_MODE, viewMode);
        window.scrollTo({
          top: 0,
          behavior: "auto"   // recomiendo auto para UX tipo e-commerce
        });
    }, [viewMode]);


    const [isHydrated, setIsHydrated] = useState(false);
    const hasReconciledSessionRef = useRef(false);
    const shouldPersistRef = useRef(false);
    // SHOP-74: distinguishes "haven't searched yet" from "searched and
    // failed" for the RESTORE effect below - without this, a persistent
    // backend failure (e.g. a 500 on basket_analysis) turns into an
    // infinite retry loop, since runBasketSearch's own catch handler resets
    // isSearching/cheapestItems to exactly the state that effect watches
    // for. Reset on every genuine search attempt (runBasketSearch), set on
    // failure - a manual retry always clears it, but the automatic RESTORE
    // effect won't keep re-triggering the same failing request on its own.
    const hasSearchFailedRef = useRef(false);
    // SHOP-195: sibling of hasSearchFailedRef above - a *successful*
    // basket_analysis response with items: [] (a legitimately empty result,
    // e.g. every selected category has zero items under the current
    // only_active rule) leaves isSearching=false/cheapestItems=[] just like
    // a fresh, not-yet-searched state, and hasSearchFailedRef alone doesn't
    // catch it (the .catch branch never runs). Without this, the RESTORE
    // effect re-triggers the same empty search forever. Reset on every
    // genuine attempt alongside hasSearchFailedRef, set only on a
    // successful-but-empty response.
    const hasSearchYieldedEmptyResultRef = useRef(false);
    useEffect(() => {
      setIsHydrated(true);
    }, []);

    useEffect(() => {
      localStorage.setItem(
        LS_SELECTED_STORES,
        JSON.stringify(selectedStores)
      );
    }, [selectedStores]);

    useEffect(() => {
      localStorage.setItem(
        LS_SORT_BY_UNIT_PRICE,
        JSON.stringify(sortByUnitPrice)
      );
    }, [sortByUnitPrice]);

    useEffect(() => {
      localStorage.setItem(
        LS_COLLAPSED_RESULT_CATEGORIES,
        JSON.stringify(collapsedResultCategories)
      );
    }, [collapsedResultCategories]);







    useEffect(() => {
      if (!isHydrated) return;
      if (!shouldPersistRef.current) return;

      localStorage.setItem(
        LS_SELECTED_CATEGORIES,
        JSON.stringify(selectedCategories)
      );

      if (selectedCategories.length === 0) {
        setViewMode(VIEW_MODES.CATEGORIES);
      }
    }, [selectedCategories, isHydrated]);

    useEffect(() => {
      if (!isHydrated) return;
      if (!shouldPersistRef.current) return;

      localStorage.setItem(
        LS_SELECTED_ITEM_QUANTITIES,
        JSON.stringify(selectedItemQuantities)
      );
    }, [selectedItemQuantities, isHydrated]);


    useEffect(() => onAuthChange(setIsLoggedIn), []);

   useEffect(() => {
      apiFetch('/stores_name')
        .then(res => res.json())
        .then(data => {
          setStores(data);

          setSelectedStores(prev => {
            // 🔒 Si ya hay stores persistidos, NO sobrescribir
            if (prev && prev.length > 0) {
              return prev;
            }
            // Solo default en primer uso
            return data;
          });
        })
        .catch(err => console.error("Error fetching stores", err));
    }, []);

    // SHOP-16: fetch the logged-in user's profile (picture_url) for the header avatar.
    useEffect(() => {
      if (!isLoggedIn) return;

      apiFetch('/auth/me')
        .then(res => {
          if (!res.ok) throw new Error('Error fetching profile');
          return res.json();
        })
        .then(data => {
          if (data) setUserProfile(data);
        })
        .catch(err => console.error('Error fetching profile', err));
    }, [isLoggedIn]);

    // SHOP-61: fetch the same price-trend data the Watched Items modal uses
    // (best_price/worst_price + current price) so the header badge can be
    // shown without waiting for the user to open that modal. Re-runs when the
    // watched-item set changes (add/remove) and whenever the Watched Items
    // modal opens/closes, so the count stays in sync with what that modal
    // actually shows.
    //
    // SHOP-69: also re-runs when selectedStores changes, since best_price/
    // worst_price are now scoped server-side to the currently selected
    // stores.
    //
    // Guarded against out-of-order responses: if this effect fires again
    // (e.g. isLoggedIn/watchedItemIds/modal-open changing in quick succession
    // during auth bootstrap) before the previous request resolves, an older
    // response arriving after a newer one must not clobber the newer, more
    // correct count with stale data.
    useEffect(() => {
      let ignoreStaleResponse = false;

      if (!isLoggedIn) {
        setWatchedItemsAlertCount(0);
        return;
      }

      apiFetch('/watchlist/details', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(selectedStores || []),
      })
        .then(res => {
          if (!res.ok) throw new Error('Error fetching watchlist details');
          return res.json();
        })
        .then(data => {
          if (ignoreStaleResponse) return;
          // SHOP-72: once an item is substituted (SHOP-71), best_price/
          // worst_price are scoped to the substitute, not the original -
          // the alert check has to compare against that same substitute's
          // price, same as WatchedItemsModal.jsx's own displayItem already does.
          const alertCount = (data || []).filter(item => {
            const displayItem = item.display_override || item;
            return getPriceStatus(displayItem.price, item.best_price, item.worst_price) === 'alert';
          }).length;
          setWatchedItemsAlertCount(alertCount);
        })
        .catch(err => {
          if (ignoreStaleResponse) return;
          console.error('Error fetching watchlist price alerts', err);
        });

      return () => {
        ignoreStaleResponse = true;
      };
    }, [isLoggedIn, watchedItemIds, isWatchedItemsModalOpen, selectedStores]);

    // SHOP-73: hydrates watchedCategoryNames as soon as the user is logged
    // in, independent of having searched. The Categories screen's
    // subcategory list now shows a watch-category icon that reads this
    // state before runBasketSearch's own success handler would otherwise
    // populate it (that only runs after a search), so it would show every
    // subcategory as unwatched for the entire session until the user
    // searched at least once without this.
    useEffect(() => {
      if (!isLoggedIn) return;

      apiFetch('/watched-categories')
        .then(response => {
          if (!response.ok) return [];
          return response.json();
        })
        .then(categories => {
          // SHOP-225: response is now [{name, name_es}]; the map stays
          // keyed on the English canonical name.
          setWatchedCategoryNames(
            normalizeWatchedCategories(categories).reduce((acc, { name }) => {
              acc[name] = true;
              return acc;
            }, {})
          );
        })
        .catch(error => {
          console.error('Error loading watched categories:', error);
        });
    }, [isLoggedIn]);

    useEffect(() => {
      if (!isHydrated) return;
      if (!selectedStores || selectedStores.length === 0) {
        setAllItems([]);
        return;
      }

      setIsLoadingAllItems(true);

      apiFetch(`/all_items${onlyActiveItems ? '?only_active=true' : ''}`, {
       method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(
          selectedStores
        ),
      })
        .then(res => {
          if (!res.ok) throw new Error('Error fetching all items');
          return res.json();
        })
        .then(data => {
          setAllItems(data || []);
        })
        .catch(err => {
          console.error('allItems error:', err);
          setAllItems([]);
        })
        .finally(() => {
          setIsLoadingAllItems(false);
        });
    }, [selectedStores, isHydrated, onlyActiveItems]);

    useEffect(() => {
      if (!infoModalCategory?.name || !selectedStores || selectedStores.length === 0) {
        setInfoModalItems([]);
        return;
      }

      let cancelled = false;

      apiFetch('/category_items', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          category: infoModalCategory.name,
          stores: selectedStores,
          only_active: onlyActiveItems,
        }),
      })
        .then(res => {
          if (!res.ok) throw new Error('Error fetching category items');
          return res.json();
        })
        .then(data => {
          if (!cancelled) setInfoModalItems(data || []);
        })
        .catch(err => {
          console.error('category_items error:', err);
          if (!cancelled) setInfoModalItems([]);
        });

      return () => {
        cancelled = true;
      };
    }, [infoModalCategory, selectedStores, onlyActiveItems]);


    useEffect(() => {
      if (
        viewMode === VIEW_MODES.ITEMS &&
        selectedStores.length > 0 &&
        selectedCategories.length > 0 &&
        cheapestItems.length === 0 &&
        !isSearching &&
        !hasSearchFailedRef.current &&
        !hasSearchYieldedEmptyResultRef.current
      ) {
        console.log('[RESTORE] Re-fetching cheapestItems');
        sendSelectedCategories();
      }
    }, [
      viewMode,
      selectedStores,
      selectedCategories,
      cheapestItems.length,
      isSearching,
    ]);

    useEffect(() => {
            // 🔒 No hacer nada hasta que el estado esté hidratado
              if (!isHydrated) return;
              if (selectedStores.length === 0) {
//              console.log("selectedStores",selectedStores)
                setCategories([]);
                setSelectedCategories([]);
                return;
              }

        apiFetch(`/all_categories${onlyActiveItems ? '?only_active=true' : ''}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(
          selectedStores
        ),
      })
            .then(response => {
                if (!response.ok) {
                    throw new Error(translations.errorFetch);
                }
                return response.json();
            })
            .then(data => {
                setCategories(data);
                const groupedData = groupCategoriesByItemCategory(data);
                setGroupedCategories(groupedData);

                // --- MODIFICACIÓN CLAVE: Inicializar todos los grupos como COLAPSED (true) ---
                const initialCollapsedState = groupedData.reduce((acc, group) => {
                    const groupKey = group.itemCategory;
                    // Establecer 'true' para que inicialmente 'isCollapsed' sea true
                    acc[groupKey] = true;
                    return acc;
                }, {});
                setCollapsedGroups(initialCollapsedState);
                // ----------------------------------------------------------------------

                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    }, [selectedStores, viewMode, isHydrated, onlyActiveItems]);

    // --- NUEVA FUNCIÓN: Volver a la selección de categorías (RESTAURADA) ---
    const handleBackToCategories = useCallback(() => {
          setViewMode(VIEW_MODES.CATEGORIES);
//          console.log('BackCat selectedItemsMap',selectedItemsMap)
         // setCheapestItems([]);
//          setSelectedItemsMap({});
          setBasketTopPrice(null);
          setSavings(null);
          setFinalPrice(null);
    }, []);
    // -----------------------------------------------------------

    const handleConfirmCategories = () => {
      setViewMode(VIEW_MODES.ITEMS);
    };

    const handleGoToItems = () => {
      setViewMode(VIEW_MODES.ITEMS);
    };


    const handleSearchItemSelect = useCallback((item) => {
      const categoryName = item.matched_category || item.category;

      setSelectedCategories((prev) => {
        const exists = prev.some((cat) => cat.name === categoryName);
        if (exists) return prev;

        const categoryObj =
          categories.find((cat) => cat.name === categoryName) ||
          { name: categoryName, name_es: item.matched_category_es || item.category_es || categoryName };

        return [...prev, categoryObj];
      });

      updateItemQuantity(item, 1);
      //setViewMode(VIEW_MODES.ITEMS);
    }, [categories, updateItemQuantity]);

    // SHOP-177: AskCopilotModal's chat results (DAO/CopilotDao.py's
    // _build_item_row shape) are a reduced/renamed shape distinct from the
    // rest of the app's item shape - {item_id, productid, precio,
    // category/category_es, activo} vs {productid, price, category,
    // is_regular_price} - so they need mapping before reaching
    // updateItemQuantity (SHOP-176's choke point), unlike
    // handleSearchItemSelect above which can pass its item straight
    // through. is_regular_price is set from !activo so an inactive chat
    // result triggers the exact same SHOP-176 warning toast as everywhere
    // else.
    //
    // SHOP-178 (2026-08-25): category matched by item.category (English,
    // same as handleSearchItemSelect above), NOT item.category_es. A live
    // bug report showed why matching on category_es text is unreliable:
    // the same category_es string can be shared by several distinct
    // English categories (e.g. "Zanahorias" alone spans 8 different
    // ItemMathes.category values in this data), so
    // categories.find(name_es === categoryEs) could silently resolve to
    // the WRONG one - a correctly-identified onion got tagged "Lila
    // Malanga" (an unrelated category that happens to share "Zanahorias"
    // too) and then never appeared in basket_analysis, which filters on
    // the exact English category. item.category is now populated
    // end-to-end from the DAO (see _category_for_productids), so this can
    // match the same reliable way handleSearchItemSelect always has.
    const handleCopilotItemSelect = useCallback((item) => {
      const categoryName = item.category;
      const categoryEs = item.category_es;
      const categoryObj = categoryName
        ? categories.find((cat) => cat.name === categoryName) || { name: categoryName, name_es: categoryEs || categoryName }
        : null;

      if (categoryObj) {
        setSelectedCategories((prev) => {
          if (prev.some((cat) => cat.name === categoryObj.name)) return prev;
          return [...prev, categoryObj];
        });
      }

      updateItemQuantity({
        productid: item.productid,
        name: item.name,
        detail: item.detail,
        store: item.store,
        price: item.precio,
        unit_price: null,
        unit: null,
        brand: null,
        enddate: null,
        special: item.special ?? null,
        category: categoryObj?.name ?? categoryName ?? categoryEs,
        category_es: categoryEs,
        matched_category: categoryObj?.name ?? categoryName ?? categoryEs,
        matched_category_es: categoryEs,
        // SHOP-228: the Copilot DAO no longer returns expired rows, so
        // activo is always true and this is always false for chat items -
        // kept only as a safety net until the activo field is retired.
        is_regular_price: item.activo === false,
        // SHOP-179: regular_price now flows through from the Copilot DAO
        // (buscar_items/obtener_precios/buscar_items_por_categoria) so
        // ProductDetails.jsx's existing active/expired strike-through
        // convention can render for chat-added cart items too.
        regular_price: item.regular_price ?? null,
      }, 1);
    }, [categories, updateItemQuantity]);

    const handleRemoveCategory = useCallback((categoryName) => {
      setSelectedCategories(prev =>
        prev.filter(cat => cat.name !== categoryName)
      );

      setSelectedItemQuantities(prev => {
        const updated = {};

        Object.entries(prev).forEach(([key, entry]) => {
          if (entry.category !== categoryName) {
            updated[key] = entry;
          }
        });

        return updated;
      });

      setExpandedCategories(prev => {
        const updated = { ...prev };
        delete updated[categoryName];
        return updated;
      });
    }, []);

    const handleToggleWatch = useCallback((item) => {
      const productid = item.productid;
      if (watchRequestsInFlightRef.current[productid]) return;

      if (!isLoggedIn) return;

      const wasWatched = !!watchedItemIds[productid];
      const nextWatched = !wasWatched;

      setWatchedItemIds(prev => {
        const updated = { ...prev };
        if (nextWatched) {
          updated[productid] = true;
        } else {
          delete updated[productid];
        }
        return updated;
      });

      watchRequestsInFlightRef.current[productid] = true;

      apiFetch(`/watchlist/${productid}`, {
        method: nextWatched ? 'POST' : 'DELETE',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Watch toggle failed: ${response.status}`);
          }
        })
        .catch(error => {
          console.error('Error toggling watch state:', error);
          setWatchedItemIds(prev => {
            const updated = { ...prev };
            if (wasWatched) {
              updated[productid] = true;
            } else {
              delete updated[productid];
            }
            return updated;
          });
          setToast({ type: 'error', text: translations.watchToggleError });
          setTimeout(() => setToast(null), 2000);
        })
        .finally(() => {
          delete watchRequestsInFlightRef.current[productid];
        });
    }, [watchedItemIds, translations, isLoggedIn]);

    // SHOP-43: mirrors handleToggleWatch above, but keyed by category name
    // instead of productid, against /watched-categories instead of /watchlist.
    const handleToggleWatchCategory = useCallback((category) => {
      if (categoryWatchRequestsInFlightRef.current[category]) return;

      if (!isLoggedIn) return;

      const wasWatched = !!watchedCategoryNames[category];
      const nextWatched = !wasWatched;

      setWatchedCategoryNames(prev => {
        const updated = { ...prev };
        if (nextWatched) {
          updated[category] = true;
        } else {
          delete updated[category];
        }
        return updated;
      });

      categoryWatchRequestsInFlightRef.current[category] = true;

      apiFetch(`/watched-categories/${encodeURIComponent(category)}`, {
        method: nextWatched ? 'POST' : 'DELETE',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Category watch toggle failed: ${response.status}`);
          }
        })
        .catch(error => {
          console.error('Error toggling watched category:', error);
          setWatchedCategoryNames(prev => {
            const updated = { ...prev };
            if (wasWatched) {
              updated[category] = true;
            } else {
              delete updated[category];
            }
            return updated;
          });
          setToast({ type: 'error', text: translations.categoryWatchToggleError });
          setTimeout(() => setToast(null), 2000);
        })
        .finally(() => {
          delete categoryWatchRequestsInFlightRef.current[category];
        });
    }, [watchedCategoryNames, translations, isLoggedIn]);

    // TES-2: unlike handleToggleWatch, the caller already knows this item is
    // watched (it came from the watched-items list itself), so this always
    // issues a DELETE rather than guessing direction off watchedItemIds,
    // which may not be hydrated yet if the user hasn't searched this session.
    const handleRemoveWatchedItem = useCallback((productid) => {
      if (!isLoggedIn) return;

      setWatchedItemIds(prev => {
        const updated = { ...prev };
        delete updated[productid];
        return updated;
      });

      apiFetch(`/watchlist/${productid}`, {
        method: 'DELETE',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Remove watched item failed: ${response.status}`);
          }
        })
        .catch(error => {
          console.error('Error removing watched item:', error);
          setToast({ type: 'error', text: translations.watchToggleError });
          setTimeout(() => setToast(null), 2000);
        });
    }, [translations, isLoggedIn]);

    // SHOP-68: wraps increaseItemQuantity (the same function the main
    // item list's QuantityStepper uses) with a confirmation toast, so the
    // watched-items "add to cart" button gets user-visible feedback without
    // adding a toast to every +/- click elsewhere in the app. The cart
    // badge itself needs no extra wiring - it already re-renders off
    // selectedItemQuantities, which increaseItemQuantity updates directly.
    //
    // Also pre-selects the item's category (mirrors handleSearchItemSelect
    // above) - without this, an item added to cart from the watched-items
    // list with no categories selected yet leaves the header's search/
    // analyze button disabled (it's gated on selectedCategories.length),
    // even though the cart is no longer empty.
    const handleAddWatchedItemToCart = useCallback((item) => {
      const categoryName = item.matched_category || item.category;

      setSelectedCategories((prev) => {
        const exists = prev.some((cat) => cat.name === categoryName);
        if (exists) return prev;

        const categoryObj =
          categories.find((cat) => cat.name === categoryName) ||
          { name: categoryName, name_es: item.matched_category_es || item.category_es || categoryName };

        return [...prev, categoryObj];
      });

      increaseItemQuantity(item);

      // SHOP-176: for an inactive/expired item, updateItemQuantity (called
      // synchronously above via increaseItemQuantity) already queued the
      // price-may-be-outdated warning toast. Skip the success toast here so
      // it doesn't overwrite that warning -- both set the same state and
      // only the last call wins.
      if (!item.is_regular_price) {
        setToast({ type: 'success', text: translations.addedToCartToast });
        setTimeout(() => setToast(null), 2000);
      }
    }, [categories, increaseItemQuantity, translations]);

    // SHOP-45: mirrors handleRemoveWatchedItem above, for the
    // WatchedCategoriesModal's remove action.
    const handleRemoveWatchedCategory = useCallback((category) => {
      if (!isLoggedIn) return;

      setWatchedCategoryNames(prev => {
        const updated = { ...prev };
        delete updated[category];
        return updated;
      });

      apiFetch(`/watched-categories/${encodeURIComponent(category)}`, {
        method: 'DELETE',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Remove watched category failed: ${response.status}`);
          }
        })
        .catch(error => {
          console.error('Error removing watched category:', error);
          setToast({ type: 'error', text: translations.categoryWatchToggleError });
          setTimeout(() => setToast(null), 2000);
        });
    }, [translations, isLoggedIn]);




    // Ejecuta la búsqueda de basket_analysis para una lista explícita de
    // categorías (SHOP-48: separado de sendSelectedCategories para poder
    // buscar con una lista que aún no llegó al estado `selectedCategories`,
    // ya que setSelectedCategories no se refleja de forma síncrona).
    const runBasketSearch = (categoryObjs) => {
        if (categoryObjs.length === 0) {
            console.error(translations.selectCategoryError);
            return;
        }
        // SHOP-74/195: every genuine attempt (manual or automatic) clears
        // both guard flags - only this attempt's own outcome sets either
        // one again.
        hasSearchFailedRef.current = false;
        hasSearchYieldedEmptyResultRef.current = false;
        setViewMode(VIEW_MODES.ITEMS);
        setIsSearching(true);
        setCheapestItems([]); // Limpiamos para la animación de carga

        const categoryNamesToSend = categoryObjs.map(categoryObj => categoryObj.name);

        apiFetch('/basket_analysis', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
           body: JSON.stringify({
                categories: categoryNamesToSend,
                stores: selectedStores,
                only_active: onlyActiveItems,
              }),
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(text => { throw new Error(`${translations.errorSend} ${text}`); });
            }
            return response.json();
        })
        .then(data => {
            setIsSearching(false);
            // SHOP-195: a legitimately empty result must not send the
            // RESTORE effect into an immediate infinite retry loop - see
            // hasSearchYieldedEmptyResultRef's declaration above.
            hasSearchYieldedEmptyResultRef.current = !data.items || data.items.length === 0;
            setCheapestItems(data.items);
            // 🔹 NUEVO: Totales globales para el header
            setBasketTopPrice(data.basket_top_price);
            setSavings(data.savings);
            setFinalPrice(data.final_price);
            const calculatedSavings =
              Number(data.basket_top_price || 0) - Number(data.final_price || 0);

            analyticsEvents.viewBasketResults({
              itemsCount: data.items?.length || 0,
              categoriesCount: categoryObjs.length,
              storesCount: selectedStores.length,
              totalPrice: data.final_price || 0,
              savingsAmount: data.savings ?? calculatedSavings,
              screenName: "basket_results",
              language,
            });

            if (isLoggedIn) {
              apiFetch('/watchlist')
                .then(response => {
                  if (!response.ok) return [];
                  return response.json();
                })
                .then(productids => {
                  setWatchedItemIds(
                    (productids || []).reduce((acc, productid) => {
                      acc[productid] = true;
                      return acc;
                    }, {})
                  );
                })
                .catch(error => {
                  console.error('Error loading watchlist:', error);
                });

              // SHOP-73: watchedCategoryNames is now hydrated by its own
              // isLoggedIn-triggered effect above, independent of search -
              // no need to re-fetch it here too.
            }
        })
        .catch(error => {
            console.error('Hubo un error:', error);
            console.error(translations.errorSendingCategories);
            // SHOP-74: marks this attempt as failed so the RESTORE effect
            // (which would otherwise see isSearching=false/cheapestItems=[]
            // right below and immediately retry) does not auto-retry the
            // same failing request forever.
            hasSearchFailedRef.current = true;
            setIsSearching(false);
            // Opcional: Si hay un error, volvemos a mostrar las categorías
            setCheapestItems([]);
            analyticsEvents.apiError({
              endpoint: "/basket_analysis",
              errorMessage: error?.message || "Unknown error",
              screenName: "categories",
            });
        });
    };

    // Función para enviar las categorías seleccionadas al API
    const sendSelectedCategories = () => {
        runBasketSearch(selectedCategories);
    };

    // SHOP-48: triggered from WatchedCategoriesModal. `validCategoryNames`
    // already excludes watched categories with 0 items for the currently
    // selected stores (computed there against the same `categories` catalog
    // passed down as `allCategories`). `mode` is 'replace' (no prior manual
    // selection, or user chose "watched only") or 'union' (user chose to
    // combine with their existing manual selection).
    const handleSearchWatchedCategories = useCallback((validCategoryNames, invalidCategoryNames, mode, invalidCategoryLabels) => {
      const watchedCategoryObjs = validCategoryNames
        .map((name) => categories.find((c) => c.name === name))
        .filter(Boolean);

      const nextSelected = mode === 'union'
        ? [
            ...selectedCategories,
            ...watchedCategoryObjs.filter(
              (wc) => !selectedCategories.some((sc) => sc.name === wc.name)
            ),
          ]
        : watchedCategoryObjs;

      setSelectedCategories(nextSelected);
      setIsWatchedCategoriesModalOpen(false);
      runBasketSearch(nextSelected);

      if (invalidCategoryNames.length > 0) {
        setToast({
          type: 'info',
          text: `${translations.watchedCategoriesExcludedNotice || 'Excluded (no items available):'} ${(invalidCategoryLabels || invalidCategoryNames).join(', ')}`,
        });
        setTimeout(() => setToast(null), 4000);
      }
    }, [categories, selectedCategories, translations, runBasketSearch]);

    // --- LÓGICA DE CÁLCULO DEL MONTO TOTAL Y MONTOS POR TIENDA (useMemo) ---


    useEffect(() => {
      if (!isHydrated) return;

      if (!selectedStores || selectedStores.length === 0) return;
      if (!allItems || allItems.length === 0) return;
      if (!categories || categories.length === 0) return;

      // Permitir re-ejecución si cambian los stores (SHOP-195): eso puede
      // cambiar qué categorías siguen calzando en `categories`, y sin este
      // reset una categoría podada del catálogo se queda "fantasma" en
      // selectedCategories. (Antes de SHOP-204 el toggle "solo items
      // vigentes" también entraba aquí, pero ahora es una constante fija que
      // nunca cambia, así que dejó de ser una dependencia útil.)
      hasReconciledSessionRef.current = false;

    }, [selectedStores]);

    useEffect(() => {
      if (!isHydrated) return;
      if (hasReconciledSessionRef.current) return;

      if (!selectedStores || selectedStores.length === 0) return;
      if (!allItems || allItems.length === 0) return;
      if (!categories || categories.length === 0) return;

      const {
        cleanedSelections,
        cleanedCategories,
      } = reconcilePersistedSession(
        selectedItemQuantities,
        selectedCategories,
        allItems,
        categories,
        selectedStores
      );

      setSelectedItemQuantities(cleanedSelections);
      setSelectedCategories(cleanedCategories);

      hasReconciledSessionRef.current = true;
      shouldPersistRef.current = true;

    }, [
      isHydrated,
      selectedStores,
      allItems,
      categories,
      selectedItemQuantities,
      selectedCategories,
      reconcilePersistedSession,
    ]);


    const formatCurrency = useCallback((amount) => {
        const finalAmount = Math.round(amount * 100) / 100;
        return finalAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
    }, []); // Se usa useCallback para la memoización de la función de formateo

    const { totalPrice, storeTotals, totalItems } = useMemo(() => {
      const selections = Object.values(selectedItemQuantities);
      let calculatedTotalPrice = 0;
      let calculatedTotalItems = 0;
      const calculatedStoreTotals = {};

      selections.forEach(entry => {
        if (!entry?.item) return;

        const price = parseFloat(String(entry.item.price).replace(/[^0-9.-]+/g, '')) || 0;
        const qty = entry.quantity || 0;
        const lineTotal = price * qty;

        calculatedTotalPrice += lineTotal;
        calculatedTotalItems += qty;

        const store = entry.item.store;
        calculatedStoreTotals[store] = (calculatedStoreTotals[store] || 0) + lineTotal;
      });

      const finalTotalPrice = Math.round(calculatedTotalPrice * 100) / 100;

      const finalStoreTotals = Object.entries(calculatedStoreTotals).reduce((acc, [store, total]) => {
        acc[store] = Math.round(total * 100) / 100;
        return acc;
      }, {});

      return {
        totalPrice: finalTotalPrice,
        storeTotals: finalStoreTotals,
        totalItems: calculatedTotalItems,
      };
    }, [selectedItemQuantities]);

    const formattedTotalPrice = formatCurrency(totalPrice);
    const savingsPercent = useMemo(() => {
      if (!basketTopPrice || basketTopPrice <= 0) return 0;
      return Math.max(0, ((basketTopPrice - totalPrice) / basketTopPrice) * 100);
    }, [basketTopPrice, totalPrice]);
    // ----------------------------------------------------------------

//    if (loading) {
//        console.log('shouldShowResults:', isSearching, cheapestItems.length, viewMode);
//
//        return <div style={{ padding: '20px' }}>{translations.loadingCategories}</div>;
//    }

    if (error) {
        return <div style={{ padding: '20px' }}>Error: {error.message}</div>;
    }

    // CLAVE: Determinar si se muestran los resultados o las categorías
    const shouldShowResults = isSearching || cheapestItems.length > 0 && viewMode === VIEW_MODES.ITEMS ;
//    console.log('shouldShowResults:', shouldShowResults, isSearching, cheapestItems.length, viewMode);
//    console.log('viewMode:', viewMode);

   const getCategoryLabel = (category) => {
      return language === 'es'
        ? category.name_es || category.name
        : category.name;
    };

    const sortedCategories = [...categories].sort((a, b) => {
      const labelA = getCategoryLabel(a);
      const labelB = getCategoryLabel(b);

      return labelA.localeCompare(labelB, language);
    });

    const sortedGroupedCategories = [...groupedCategories].sort(
      (a, b) => {
        const labelA = getTranslatedGroupTitle(a);
        const labelB = getTranslatedGroupTitle(b);

        return labelA.localeCompare(labelB, language);
      }
    );


    return (
       <div style={{ margin: '0', padding: '0', width: '100%' }}>
        {/* --- MODAL DE SUBIDA DE ARCHIVOS (Renderizado) --- */}
        <FileUploadModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          translations={translations}
          onUploadSuccess={handleUploadSuccess}
        />

        {/* --- MODAL DE LISTA DE COMPRAS (Renderizado - RESTAURADO) --- */}
        <ShoppingListModal
            isOpen={isListModalOpen}
            onClose={() => setIsListModalOpen(false)}
            selectedItemsMap={flattenedSelectedItemsMap}
            storeTotals={storeTotals}
            formatCurrency={formatCurrency}
            translations={translations}
            language={language}
            onRemoveItem={(item) => updateItemQuantity(item, 0)}
            onIncreaseItem={increaseItemQuantity}
            onDecreaseItem={(item) => {
              // SHOP-133: unlike the ITEMS view's stepper, the cart modal's
              // minus button floors at 1 instead of removing the item -
              // removal here only happens via the SHOP-132 delete button.
              if (getItemQuantity(item) > 1) {
                decreaseItemQuantity(item);
              }
            }}
        />

        <SlidePanel
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          title={translations.settings}
          closeLabel={translations.modalClose}
          isMobile={isMobile}
        >
          {/* Stores: the primary action, so it comes first and gets a
              denser multi-column layout - the store list can run into the
              dozens (SHOP-8), so a single-column checkbox stack doesn't fit
              a mobile viewport without excess scrolling. */}
          <div style={{ padding: '16px' }}>
            <h4 style={{ marginBottom: '10px' }}>{translations.stores}</h4>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                columnGap: '12px',
                rowGap: '8px',
                marginBottom: '12px',
              }}
            >
              {stores.map(store => (
                <label
                  key={store}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '15px',
                    fontWeight: 500,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedStores.includes(store)}
                    onChange={() =>
                      setSelectedStores(prev =>
                        prev.includes(store)
                          ? prev.filter(s => s !== store)
                          : [...prev, store]
                      )
                    }
                  />
                  {store}
                </label>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
              <button
                onClick={() => setSelectedStores([])}
                style={{ background: 'none', border: 'none', color: '#2563EB', fontSize: '15px', fontWeight: 500, cursor: 'pointer' }}
              >
                {translations.unselectAll}
              </button>

              <button
                onClick={() => setSelectedStores([...stores])}
                style={{ background: 'none', border: 'none', color: '#2563EB', fontSize: '15px', fontWeight: 500, cursor: 'pointer' }}
              >
                {translations.selectAll}
              </button>
            </div>

            {/* Contact Us: secondary, condensed - no longer an
                always-expanded block pushing Stores below the fold. */}
            <div style={{ borderTop: '1px solid #eee', paddingTop: '16px' }}>
              <h4 style={{ marginBottom: '8px' }}>{translations.contactUsTitle}</h4>

              <p style={{ fontSize: '14px', color: '#555', marginBottom: '8px', lineHeight: '1.4' }}>
                {translations.contactUsPrompt}
              </p>

              <a
                href="mailto:shopcopilot.app@gmail.com?subject=ShopCopilot Feedback"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#2563EB',
                  fontSize: '15px',
                  fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                📧 support@shopcopilot.app
              </a>
            </div>
          </div>
        </SlidePanel>


        {/* --- CABECERA Y BOTÓN DE BÚSQUEDA FIJOS --- */}
        <CategoryHeader
          translations={translations}
          language={language}
          selectedCategoriesCount={selectedCategories.length}
          shouldShowResults={shouldShowResults}
          formattedTotalPrice={formattedTotalPrice}
          storeTotals={storeTotals}
          isLoggedIn={isLoggedIn}
          profilePictureUrl={userProfile?.picture_url}
          formatCurrency={formatCurrency}
          onOpenUploadModal={() => setIsModalOpen(true)}
          onHandleBackToCategories={handleBackToCategories}
          onHandleGoToList={() => setIsListModalOpen(true)}
          onToggleLanguage={handleLanguageToggle}
          onSearch={sendSelectedCategories}
          isSearching={isSearching}
          disableSearch={selectedCategories.length === 0 || shouldShowResults}
          onHeightChange={setHeaderHeight}
          onOpenFilter={() => setIsFilterOpen(true)}
          viewMode={viewMode}
          onOpenItemSearchModal={() => setIsItemSearchOpen(true)}
          onOpenAskCopilot={() => setIsAskCopilotOpen(true)}
          onResetAll={handleResetAll}
          onOpenWatchedItems={() => setIsWatchedItemsModalOpen(true)}
          onOpenWatchedCategories={() => setIsWatchedCategoriesModalOpen(true)}
          watchedItemsAlertCount={watchedItemsAlertCount}
          sortByUnitPrice={sortByUnitPrice}
          onToggleSortByUnitPrice={handleToggleSortByUnitPrice}
          />

        <WatchedItemsModal
          isOpen={isWatchedItemsModalOpen}
          onClose={() => setIsWatchedItemsModalOpen(false)}
          translations={translations}
          formatCurrency={formatCurrency}
          onRemoveWatchedItem={handleRemoveWatchedItem}
          onAddToCart={handleAddWatchedItemToCart}
          selectedStores={selectedStores}
        />

        {cartChooserItem && (
          <ChooseCartItemModal
            isOpen
            originalItem={cartChooserItem}
            equivalentItem={cartChooserItem.matched_equivalent}
            onChoose={handleChooseCartItem}
            onChooseBoth={handleChooseBothCartItems}
            onCancel={handleCancelCartChooser}
            translations={translations}
            formatCurrency={formatCurrency}
          />
        )}

        <WatchedCategoriesModal
          isOpen={isWatchedCategoriesModalOpen}
          onClose={() => setIsWatchedCategoriesModalOpen(false)}
          translations={translations}
          language={language}
          onRemoveWatchedCategory={handleRemoveWatchedCategory}
          allCategories={categories}
          hasManualSelection={selectedCategories.length > 0}
          onSearchWatchedCategories={handleSearchWatchedCategories}
        />

        <ItemSearchModal
          isOpen={isItemSearchOpen}
          onClose={() => setIsItemSearchOpen(false)}
          items={allItems}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          selectedItemsMap={{}}
          setSelectedItemsMap={() => {}}
          formatCurrency={formatCurrency}
          onSelectItem={handleSearchItemSelect}
        />

        <AskCopilotModal
          isOpen={isAskCopilotOpen}
          onClose={() => setIsAskCopilotOpen(false)}
          translations={translations}
          language={language}
          selectedStores={selectedStores}
          onSelectItem={handleCopilotItemSelect}
        />

        <SubcategoryItemsModal
          isOpen={!!infoModalCategory}
          onClose={() => setInfoModalCategory(null)}
          category={infoModalCategory}
          items={infoModalItems}
          translations={translations}
          language={language}
          formatCurrency={formatCurrency}
          onAddToCart={handleAddWatchedItemToCart}
        />

        {/* Toast: previously nested inside the CATEGORIES-only block, so it
            never actually rendered for actions taken from the ITEMS view
            (e.g. watch-toggle errors, and SHOP-48's excluded-categories
            notice). Hoisted here so it's independent of viewMode. */}
        {toast && (
          <div
            style={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              width: '100%',
              padding: '14px 16px',
              background: toast.type === 'success' ? '#10B981' : toast.type === 'info' ? '#2563EB' : '#EF4444',
              color: '#FFFFFF',
              borderTop: '1px solid',
              borderColor: toast.type === 'success' ? '#059669' : toast.type === 'info' ? '#1D4ED8' : '#DC2626',
              fontSize: '0.95em',
              fontWeight: 600,
              zIndex: 3000,
              boxShadow:
                toast.type === 'success'
                  ? '0 -6px 20px rgba(16,185,129,0.45)'
                  : toast.type === 'info'
                  ? '0 -6px 20px rgba(37,99,235,0.45)'
                  : '0 -6px 20px rgba(239,68,68,0.45)',
              textAlign: 'center',
            }}
          >
            {toast.text}
          </div>
        )}

        {/* --- CONTENIDO PRINCIPAL --- */}
        <div
          style={{
            paddingTop: `${headerHeight + 10}px`, // margen de seguridad
            maxWidth: '1200px',
            margin: '0 auto',
            minHeight: '100vh',
            paddingBottom: '20px'
          }}
        >

            {/* --- Renderizado de Categorías Agrupadas por itemCategory --- */}
            {/* CLAVE: Se muestra SÓLO si no se está buscando y no hay resultados */}
  {loading && (
              <h2 style={{ textAlign: 'center', color: '#007bff' }}>
                {translations.loadingCategories}
              </h2>
            )}
{viewMode === VIEW_MODES.CATEGORIES && (
  <div style={{ marginBottom: '30px' }}>
            { (
                <div style={{ marginBottom: '30px' }}>
                    {sortedGroupedCategories.map((group, groupIndex) => {
                        const rawGroupKey = group.itemCategory;
                        const translatedTitle = getTranslatedGroupTitle(group);
                        const groupKey = rawGroupKey || `Otras Categorías ${groupIndex}`;
                        // 1. Obtener el nombre del icono (ej. "Apple") usando la llave original en inglés
                        // NOTA: Usa la variable que tiene el nombre original de la categoría, ej: group.name
                        const iconName = getIconName(rawGroupKey);

                        // 2. Obtener el componente real de Lucide
                        const IconComponent = LucideIcons[iconName] || LucideIcons.ShoppingBasket;
                        // isCollapsed ahora es true por defecto gracias a la inicialización en useEffect
                        const isCollapsed = collapsedGroups[groupKey];
                        // SHOP-203: same identity check the per-subcategory row already uses for
                        // isSelected (line ~2065), applied across the whole group so the collapsed
                        // pill can hint that a selection is inside without expanding it.
                        const hasSelectedSubcategory = group.categories.some(
                            categoryObj => selectedCategories.some(sc => sc.name === categoryObj.name)
                        );
//                        console.log("Encabezado de la División");
                        return (
                            <div
                                key={groupKey}
                                style={{
                                    marginBottom: '15px',
                                    padding: '0',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    backgroundColor: '#f9f9f9'
                                }}
                            >
                                {/* Encabezado de la División (itemCategory) */}
                                <div
                                    onClick={() => toggleGroup(groupKey)}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        backgroundColor: '#e9f5ff',
                                        borderBottom: isCollapsed ? 'none' : '1px solid #b3d9ff',
                                        borderRadius: '10px 10px 0 0',
                                        transition: 'background-color 0.2s'
                                    }}
                                >
                                    <h2
                                      style={{
                                        fontSize: 'clamp(1.2rem, 1.8vw, 1.6rem)',
                                        fontWeight: '700',
                                        margin: 0,
                                        color: '#007bff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        minWidth: 0,
                                        overflow: 'hidden'
                                      }}
                                    >
                                      <IconComponent size={18} style={{ marginRight: '5px', flexShrink: 0 }} />

                                      <span
                                        style={{
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          minWidth: 0,
                                          flexShrink: 1
                                        }}
                                        title={`${translatedTitle || translations.otherCategories} (${group.categories.length})`}
                                      >
                                        {translatedTitle || translations.otherCategories} ({group.categories.length})
                                      </span>
                                    </h2>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                        {hasSelectedSubcategory && (
                                            <span
                                                data-testid="category-group-selection-badge"
                                                title={translations.hasSelectedSubcategory}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#00c853',
                                                    flexShrink: 0
                                                }}
                                            >
                                                <FiCheck size={13} color="#ffffff" strokeWidth={3} />
                                            </span>
                                        )}
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="#007bff"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{ transform: `rotate(${isCollapsed ? 0 : 90}deg)`, transition: 'transform 0.3s' }}
                                        >
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </div>
                                </div>

                                {/* Lista de Categorías (Renderizado Condicional) */}
                                {/* CLAVE: !isCollapsed es true solo cuando el usuario lo expande */}
                                {!isCollapsed && (
                                    <ul style={{
                                        listStyle: 'none',
                                        padding: '5px',
                                        margin: 0,
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                                        columnGap: '40px',
                                        rowGap: '5px',
                                        transition: 'height 0.3s ease-out',
                                        overflow: 'hidden'
                                    }}>
                                        {getSortedCategoriesByLanguage(group.categories).map(
                                            (categoryObj, catIndex) => {
                                            const isSelected = selectedCategories.some(
                                                selectedCat => selectedCat.name === categoryObj.name
                                            );
                                            // SHOP-73: same identity space watchedCategoryNames already
                                            // shares with WatchedCategoriesModal and the ITEMS-view toggle
                                            // (SHOP-43) - categoryObj.name is the canonical category name.
                                            const isCategoryWatched = !!watchedCategoryNames[categoryObj.name];
                                            // ID único para el checkbox/label
                                            const categoryId = `cat-${categoryObj.name.replace(/\s+/g, '-')}-${groupIndex}-${catIndex}`;
//                                            console.log('🔥 JSX EXECUTED');
                                            return (
                                                <li key={catIndex}>
                                                    {/* 1. Checkbox Oculto (funcional) */}
                                                    <input
                                                        type="checkbox"
                                                        id={categoryId}
                                                        checked={isSelected}
                                                        onChange={() => handleCheckboxChange(categoryObj)}
                                                        // Ocultar visualmente pero mantener en el flujo para A11y
                                                        style={{ position: 'absolute', opacity: 0, height: 0, width: 0 }}
                                                    />

                                                    {/* 2. Etiqueta (Label) que actúa como botón visual */}
                                                    <label
                                                        htmlFor={categoryId}
                                                        tabIndex={0} // Asegura que el label sea enfocable por teclado
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            cursor: 'pointer',
                                                            width: '90%',
                                                            backgroundColor: isSelected ? '#f0fff4' : '#ffffff',
                                                            color: '#333',
                                                            padding: '12px 15px',
                                                            borderRadius: '8px',
                                                            border: isSelected ? '2px solid #00c853' : '1px solid #ddd',
                                                            transition: 'all 0.2s',
                                                            fontWeight: '600',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                                            userSelect: 'none',
                                                            // Estilos de foco para usuarios de teclado
                                                            outline: 'none'
                                                        }}
                                                        // Manejador de foco: para mejorar la experiencia de teclado (Opcional)
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault(); // Previene la acción por defecto si la hay
                                                                // Al estar asociado al input, no es estrictamente necesario, pero mejora la robustez
                                                                handleCheckboxChange(categoryObj);
                                                            }
                                                        }}
                                                    >
                                                        <span style={{ marginRight: '10px', flexGrow: 1 }}>
                                                            <span style={{ display: 'block', fontSize: '1.1em' }}>
                                                                {
                                                                language === 'es'
                                                                    ? categoryObj.name_es || categoryObj.name
                                                                    : categoryObj.name
                                                                }
                                                                {Number.isFinite(categoryObj.itemCount) && (
                                                                    <span style={{
                                                                        marginLeft: '6px',
                                                                        fontSize: '0.85em',
                                                                        fontWeight: 'normal',
                                                                        opacity: isSelected ? 0.85 : 0.6
                                                                    }}>
                                                                        ({categoryObj.itemCount})
                                                                    </span>
                                                                )}
                                                            </span>
                                                            <span style={{
                                                                display: 'block',
                                                                fontSize: '0.8em',
                                                                fontWeight: 'normal',
                                                                opacity: isSelected ? 0.8 : 0.6
                                                            }}>
                                                                {/* (categoryObj.itemCategory) - Omitido para limpieza, ya está en el header */}
                                                            </span>
                                                        </span>
                                                        {/* SHOP-73: watch-category toggle, before Info per product
                                                            decision. Invisible for logged-out users, same gate as
                                                            the other two watch icons (SHOP-11/SHOP-43). Toggles the
                                                            same watchedCategoryNames/handleToggleWatchCategory this
                                                            file already uses from the ITEMS view and
                                                            WatchedCategoriesModal - no separate state or endpoint. */}
                                                        {isLoggedIn && (isCategoryWatched ? (
                                                            <MdBookmark
                                                                data-testid="subcategory-watch-icon"
                                                                size={22}
                                                                role="button"
                                                                tabIndex={0}
                                                                aria-label={translations.unwatchCategory || 'Unwatch category'}
                                                                title={translations.unwatchCategory || 'Unwatch category'}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    handleToggleWatchCategory(categoryObj.name);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleToggleWatchCategory(categoryObj.name);
                                                                    }
                                                                }}
                                                                style={{
                                                                    marginRight: '8px',
                                                                    flexShrink: 0,
                                                                    color: '#007bff',
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        ) : (
                                                            <MdBookmarkBorder
                                                                data-testid="subcategory-watch-icon"
                                                                size={22}
                                                                role="button"
                                                                tabIndex={0}
                                                                aria-label={translations.watchCategory || 'Watch category'}
                                                                title={translations.watchCategory || 'Watch category'}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    handleToggleWatchCategory(categoryObj.name);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        handleToggleWatchCategory(categoryObj.name);
                                                                    }
                                                                }}
                                                                style={{
                                                                    marginRight: '8px',
                                                                    flexShrink: 0,
                                                                    color: '#6c757d',
                                                                    cursor: 'pointer'
                                                                }}
                                                            />
                                                        ))}
                                                        {/* Icono informativo: abre un modal con los artículos de la subcategoría */}
                                                        <LucideIcons.Info
                                                            data-testid="subcategory-info-icon"
                                                            size={24}
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-label={translations.viewSubcategoryItems}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                setInfoModalCategory(categoryObj);
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setInfoModalCategory(categoryObj);
                                                                }
                                                            }}
                                                            style={{
                                                                marginRight: '8px',
                                                                flexShrink: 0,
                                                                color: '#6c757d',
                                                                opacity: isSelected ? 0.85 : 0.6,
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                        <CartIcon isSelected={isSelected} />
                                                    </label>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
  </div>
)}


            {/* --- Lógica de Renderizado de Artículos (Reemplazando Contenido) --- */}
            {/* CLAVE: Se muestra SÓLO si se está buscando o si hay resultados */}
           {viewMode === VIEW_MODES.ITEMS && (
          <div style={{ marginTop: '10px' }}>

            {isSearching && (
              <h2 style={{ textAlign: 'center', color: '#007bff' }}>
                {translations.loadingItems}
              </h2>
            )}

                    {!isSearching && shouldShowResults && cheapestItems.length > 0 && (
                      <>
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                            gap: '20px'
                          }}
                        >
                          {groupedVisibleItems.map((group) => {
                            const categorySelectedCount = getSelectedCountByCategory(group.category);
                            const categorySubtotal = getCategorySubtotal(group.category);
                            const isResultCategoryCollapsed = !!collapsedResultCategories[group.category];

                            return (
                              <div
                                key={group.category}
                                style={{
                                  borderRadius: '14px',
                                  overflow: 'hidden',
                                  background: '#fff',
                                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                  border: '1px solid #e5e7eb'
                                }}
                              >
                                {/* Header categoría */}
                                <div
                                  data-testid="result-category-header"
                                  onClick={() => toggleResultCategoryCollapse(group.category)}
                                  onMouseEnter={() => setHoveredResultCategory(group.category)}
                                  onMouseLeave={() => setHoveredResultCategory(null)}
                                  title={isResultCategoryCollapsed
                                    ? (translations.expandCategory || 'Click to expand category')
                                    : (translations.collapseCategory || 'Click to collapse category')}
                                  aria-label={isResultCategoryCollapsed
                                    ? (translations.expandCategory || 'Click to expand category')
                                    : (translations.collapseCategory || 'Click to collapse category')}
                                  style={{
                                    padding: '12px 14px',
                                    background: hoveredResultCategory === group.category ? '#dbeafe' : '#e9f5ff',
                                    borderBottom: isResultCategoryCollapsed ? 'none' : '1px solid #dbeafe',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  <div>
                                    <div style={{ fontSize: '1.05em', fontWeight: 700, color: '#007bff' }}>
                                      {group.title}
                                    </div>
                                    <div style={{ fontSize: '0.9em', color: '#475569', marginTop: '4px' }}>
                                      🛒 {categorySelectedCount} items · {formatCurrency(categorySubtotal)}
                                    </div>
                                  </div>

                                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#007bff"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      style={{
                                        transform: `rotate(${isResultCategoryCollapsed ? 0 : 90}deg)`,
                                        transition: 'transform 0.3s',
                                        flexShrink: 0
                                      }}
                                    >
                                      <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                    {isLoggedIn && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleToggleWatchCategory(group.category);
                                        }}
                                        title={watchedCategoryNames[group.category]
                                          ? (translations.unwatchCategory || 'Unwatch category')
                                          : (translations.watchCategory || 'Watch category')}
                                        aria-label={watchedCategoryNames[group.category]
                                          ? (translations.unwatchCategory || 'Unwatch category')
                                          : (translations.watchCategory || 'Watch category')}
                                        style={{
                                          background: '#fff',
                                          border: '1px solid #e2e8f0',
                                          borderRadius: '999px',
                                          width: '32px',
                                          height: '32px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          cursor: 'pointer',
                                          boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                                        }}
                                      >
                                        {watchedCategoryNames[group.category]
                                          ? <MdBookmark size={18} color="#007bff" />
                                          : <MdBookmarkBorder size={18} color="#6c757d" />}
                                      </button>
                                    )}

                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveCategory(group.category);
                                      }}
                                      title={translations.removeCategory || 'Remove category'}
                                      style={{
                                        background: '#fff',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '999px',
                                        width: '32px',
                                        height: '32px',
                                        cursor: 'pointer',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                                      }}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>

                                {/* Lista items */}
                                {!isResultCategoryCollapsed && (
                                <div style={{ padding: '10px' }}>
                                  {(expandedCategories[group.category] ? group.items : group.items.slice(0, 3)).map((item, idx) => {
                                    const qty = getItemQuantity(item);
                                    const isSelected = qty > 0;
                                    const isMain = idx === 0;
                                    const hasSpecialOffer = item?.special && item.special !== 'No';

                                    return (
                                      <div
                                        key={item.productid}
                                        data-testid="item-card"
                                        style={{
                                          border: isSelected ? '2px solid #00c853' : '1px solid #e5e7eb',
                                          backgroundColor: hasSpecialOffer ? '#ffe0b2' : (isSelected ? '#f0fff4' : '#ffffff'),
                                          borderRadius: '12px',
                                          padding: '10px',
                                          paddingRight: isLoggedIn ? '44px' : '10px',
                                          marginBottom: '10px',
                                          transition: 'all 0.2s',
                                          position: 'relative'
                                        }}
                                      >
                                        {isLoggedIn && (
                                          <button
                                            onClick={() => handleToggleWatch(item)}
                                            title={watchedItemIds[item.productid]
                                              ? (translations.removeFromWatchList || 'Remove from watch list')
                                              : (translations.addToWatchList || 'Add to watch list')}
                                            aria-label={watchedItemIds[item.productid]
                                              ? (translations.removeFromWatchList || 'Remove from watch list')
                                              : (translations.addToWatchList || 'Add to watch list')}
                                            style={{
                                              position: 'absolute',
                                              top: '8px',
                                              right: '8px',
                                              background: '#fff',
                                              border: '1px solid #e2e8f0',
                                              borderRadius: '999px',
                                              width: '32px',
                                              height: '32px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              cursor: 'pointer',
                                              boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                              zIndex: 1
                                            }}
                                          >
                                            {watchedItemIds[item.productid]
                                              ? <MdBookmark size={18} color="#007bff" />
                                              : <MdBookmarkBorder size={18} color="#6c757d" />}
                                          </button>
                                        )}

                                        {item.productid === group.priceWinnerId && (
                                          <div
                                            style={{
                                              display: 'inline-block',
                                              background: '#dcfce7',
                                              color: '#166534',
                                              fontSize: '0.75em',
                                              fontWeight: 700,
                                              borderRadius: '999px',
                                              padding: '4px 8px',
                                              marginBottom: '8px',
                                              marginRight: '6px'
                                            }}
                                          >
                                            🏆 {translations.bestPrice || 'Best price'}
                                          </div>
                                        )}

                                        {item.productid === group.unitPriceWinnerId && (
                                          <div
                                            style={{
                                              display: 'inline-block',
                                              background: '#ffe0b2',
                                              color: '#ff5722',
                                              fontSize: '0.75em',
                                              fontWeight: 700,
                                              borderRadius: '999px',
                                              padding: '4px 8px',
                                              marginBottom: '8px'
                                            }}
                                          >
                                            🏷️ {translations.bestUnitPrice || 'Best unit price'}
                                          </div>
                                        )}

                                        <ProductDetails
                                          item={item}
                                          isMain={isMain}
                                          language={language}
                                          translations={translations}
                                          isSelected={isSelected}
                                          formatCurrency={formatCurrency}
                                        />

                                        <div
                                          data-testid="item-actions-row"
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: '12px',
                                            marginTop: '10px',
                                            flexWrap: 'wrap',
                                            width: '100%'
                                          }}
                                        >
                                          <QuantityStepper
                                            quantity={qty}
                                            onDecrease={() => decreaseItemQuantity(item)}
                                            onIncrease={() => increaseItemQuantity(item)}
                                          />

                                          {item.fromshopper && item.shopper_url && !item.is_regular_price && (
                                            <a
                                              href={item.shopper_url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              title="Ver en el Shopper"
                                              aria-label="Ver en el Shopper"
                                              onClick={() =>
                                                analyticsEvents.clickViewInShopper({
                                                  item,
                                                  screenName: "basket_results",
                                                  language,
                                                })
                                              }
                                              style={{
                                                flex: 1,
                                                minWidth: 0,
                                                height: '36px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                fontSize: '0.75em',
                                                textAlign: 'center',
                                                color: '#2563EB',
                                                fontWeight: 600,
                                                textDecoration: 'none',
                                                border: '1px solid #bfdbfe',
                                                background: '#eff6ff',
                                                padding: '0 8px',
                                                borderRadius: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                              }}
                                            >
                                              Ver en el Shopper
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}

                                  {group.items.length > 3 && (
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '6px' }}>
                                      <button
                                        onClick={() => toggleExpandedCategory(group.category)}
                                        style={{
                                          background: '#fff',
                                          border: '1px solid #cbd5e1',
                                          borderRadius: '999px',
                                          padding: '8px 14px',
                                          cursor: 'pointer',
                                          fontWeight: 600,
                                          fontSize: '0.9em',
                                          color: '#334155',
                                        }}
                                      >
                                        {expandedCategories[group.category]
                                          ? (translations.showLessItems || 'Mostrar menos')
                                          : `${translations.showMoreItems || 'Mostrar más'} (${group.items.length - 3})`}
                                      </button>
                                    </div>
                                  )}
                                </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    )}
                    {/* Mensaje de "No se encontraron resultados" */}
                    {viewMode === VIEW_MODES.ITEMS && totalItems > 0 && (
                      <div
                        style={{
                          position: 'sticky',
                          bottom: 0,
                          marginTop: '20px',
                          background: 'rgba(255,255,255,0.96)',
                          backdropFilter: 'blur(8px)',
                          borderTop: '1px solid #e5e7eb',
                          padding: '12px 16px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: '12px',
                          boxShadow: '0 -4px 14px rgba(0,0,0,0.08)',
                          zIndex: 30
                        }}
                      >
                        <div>
                          <div style={{ fontWeight: 700, fontSize: '1em' }}>
                            🛒 {totalItems} items | {formattedTotalPrice}
                          </div>
                          <div style={{ fontSize: '0.9em', color: '#475569', marginTop: '2px' }}>
                            {translations.savings || 'Savings'} {savingsPercent.toFixed(0)}%
                          </div>
                        </div>

                        <button
                          onClick={() => setIsListModalOpen(true)}
                          style={{
                            background: '#14532D',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '12px 16px',
                            fontWeight: 700,
                            cursor: 'pointer'
                          }}
                        >
                          {translations.viewCart || 'Ver carrito'}
                        </button>
                      </div>
                    )}
                    {!isSearching && cheapestItems.length === 0 && selectedCategories.length > 0 && (
                        <div style={{ textAlign: 'center', padding: '50px', color: '#6c757d', border: '1px solid #ddd', borderRadius: '8px' }}>
                            {translations.noResults}
                             <button
                                onClick={handleBackToCategories}
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '1em',
                                }}
                            >
                                {translations.backButton}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    </div>
    );
}

export default ProdCategories;